<!-- Header -->
<div class="popup">
    <div style="padding:10px;margin-bottom:70px;">
        <div class="modal-headerTitle" style="padding-left:10px;padding-top:10px;text-align:center;">Legend</div>
        <table style="width:100%;">
            <thead>
                <!-- <tr>
                    <th></th>
                    <th width="150px">Color</th> 
                    <th width="150px">Level</th>

                </tr> -->
            </thead>
            <tbody>
                <tr>
                    <td style="border: 1px solid silver; width:40px; height:40px; text-align:center; margin-top:10px;" 
                        [ngStyle]="{ 'background-color': backgroundColorForUserDefinedDefinition }">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </td>
                    <td style="width:100%; text-align:left; margin-top:10px; margin-left: 20px;">
                        &nbsp;&nbsp;&nbsp;&nbsp;{{ legendItem_1 }}  
                    </td>

                </tr>
                <tr>
                    <td style="border: 1px solid silver; width:40px;  height:40px; text-align:center; margin-top:10px;" 
                        [ngStyle]="{ 'background-color': backgroundColorForDistrictDefinedDefinition }">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </td>
                    <td style="width:100%;text-align:left;margin-top:10px; margin-left: 15px;">
                        &nbsp;&nbsp;&nbsp;&nbsp;{{ legendItem_2 }}
                    </td>


                </tr>
                <!-- <tr class="tableOddRow">
                    <td style="width:100%;text-align:center; background-color:powderblue;margin-top:10px;">System
                        
                    </td>


                </tr> -->

            </tbody>
        </table>

        <div class="sis-app-footer">
            <tyl-button style="float:right;" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
        </div>
    </div>
</div>